import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import React, { useEffect } from "react";
import ErrorPage from "./components/fallbacks/ErrorPage";
import { ConfigProvider } from "antd";
import Login from "./components/signin/Login";
import Register from "./components/signup/Register";
import ForgotPassword from "./components/forgotpassword/ForgotPassword";
import VerifyUser from "./components/verifypassword/VerifyUser";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import TwoFactor from "./components/TwoFactor";
import ErrorBoundary from "./error/ErrorBoundary";

function App() {

  const router = createBrowserRouter([
    {
      path: "signin",
      element: (
        <ErrorBoundary>
          <Login />
        </ErrorBoundary>
      ),
    },
    {
      path: "signup",
      element: (
        <ErrorBoundary>
          <Register />
        </ErrorBoundary>
      ),
    },
    {
      path: "signin/two-factor",
      element: (
        <ErrorBoundary>
          <TwoFactor />
        </ErrorBoundary>
      ),
    },
    {
      path: "forget-password",
      element: (
        <ErrorBoundary>
          <ForgotPassword />
        </ErrorBoundary>
      ),
    },
    {
      path: "reset-password",
      element: (
        <ErrorBoundary>
          <ResetPassword />
        </ErrorBoundary>
      ),
    },
    {
      path: "governify/verify",
      element: (
        <ErrorBoundary>
          <VerifyUser />
        </ErrorBoundary>
      ),
    },
    { path: "*", element: <ErrorPage /> },
  ]);

  useEffect(() => {
    if(window.location.href == 'https://governify.tasc360.com/' || window.location.href == 'https://governify.tasc360.com'){
      window.location.href = 'https://governify.tasc360.com/signin';
    }
  },[])

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: "#59C080",
            headerColor: "#fff",
          },
          Checkbox:{
              colorPrimary: "#51bc90" ,
              colorPrimaryHover: "#51bc90"
          }
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
